/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,
    ClipPath,
    Use,
    Defs,
    Stop
} from 'react-native-svg';



//     <style>.cls-1,.cls-2{fill: none;}.cls-2{clip - rule: evenodd;}
// .cls-3{clip - path: url(#clip-path);}
// .cls-4{clip - path: url(#clip-path-2);}
// .cls-5{fill: #69c9ca;}
// .cls-6{clip - path: url(#clip-path-3);}
// .cls-7{fill: #fff;}</style>
  
export const SvgCoffee = ({ size, selected = false }) => {
    const fillColor = selected ? 'red' : '#69c9ca'
    return (<Svg width={size} height={size} viewBox="0 0 82.32 82.14">
        <ClipPath id="clip-path">
            <Circle 
            fill = "none"
            class="cls-1" cx="41.32" cy="41.06" r="40" />
        </ClipPath>
        <ClipPath id="clip-path-2">
            <Rect
            fill = "none"
             class="cls-1" x="0.32" y="0.06" width="82" height="82" />
        </ClipPath>
        <ClipPath id="clip-path-3">
            <Path
            clipRule= "evenodd"
            fill = "none"
             class="cls-2" d="M21.71,54.44c-.39-.39-.26-.71.3-.71H60c.56,0,.7.31.3.71l-.58.58a2.8,2.8,0,0,1-1.71.71H24A2.76,2.76,0,0,1,22.28,55Zm34.94-22A5.33,5.33,0,1,1,56,43.06a6,6,0,0,1-1.78-.27A40.65,40.65,0,0,0,56.64,32.43Zm-3.2,12.22a8,8,0,0,0,2.55.42,7.33,7.33,0,0,0,.77-14.63A2.7,2.7,0,0,0,54,27.73H28a2.59,2.59,0,0,0-2.64,3s1.41,17,8.31,21.7H48.33A27.77,27.77,0,0,0,53.45,44.65Z" />
        </ClipPath>

        <G 
        clipPath = "url(#clip-path)"
        class="cls-3">
            <G class="cls-4">
                <Rect class="cls-5"
                fill = {fillColor}
                 x="-3.68" y="-3.94" width="90" height="90" />
            </G>
        </G>
        <G  clipPath = "url(#clip-path-3)"
        class="cls-6">
        <G 
      
        clipPath = "url(#clip-path-2)"
        class="cls-4">
            <Rect
            fill ="#fff"
             class="cls-7" x="16.48" y="22.73" width="52.18" height="38" /></G>
        </G>
    </Svg >)
}

